import React, { Component, Fragment } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import moment from "moment";
import { Form } from "react-bootstrap";
import { jsPDF } from "jspdf";

// import component
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";

// import action
import { getFollowersHistory } from "../../actions/copyTradeAction";

// import library
import { firstLetterCase } from "../../lib/capitalize";

class Followers extends Component {
    constructor(props) {
        super(props);

        this.columns = [
            {
                key: "user",
                text: "User",
                className: "identifier",
                align: "left",
                sortable: true,
                cell: (record) => {
                    return record.user.name;
                },
            },
            {
                key: "history.total",
                text: "Total",
                className: "approval",
                align: "left",
                sortable: true,
                cell: (record) => {
                    return record.history ? record.history.total:0;
                }
            },
            {
                key: "history.gain",
                text: "Gain",
                className: "approval",
                align: "left",
                sortable: true,
                cell: (record) => {
                    return record.history ? record.history.gain:0;
                }
            },
            {
                key: "history.loss",
                text: "Loss",
                className: "approval",
                align: "left",
                sortable: true,
                cell: (record) => {
                    return record.history ? record.history.loss:0;
                }
            },
            {
                key: "history.profitnloss",
                text: "Profit And Loss (INR)",
                className: "profitnloss",
                align: "left",
                sortable: true,
                cell: (record) => {
                    return record.history ? record.history.profitnloss:0;
                }
            },
            {
                key: "history.ratio",
                text: "P/L Ratio",
                className: "approval",
                align: "left",
                sortable: true,
                cell: (record) => {
                    if (record.history && record.history.ratio > 0)
                        return <span className="text-success">{record.history.ratio} %</span>;
                    else if(record.history && record.history.ratio < 0)
                        return <span className="text-danger">{record.history.ratio} %</span>;
                    else
                        return 0;
                },
            },
            {
                key: "tradersCount",
                text: "Following Traders",
                className: "tradersCount",
                align: "left",
                sortable: true,
                cell: (record) => {
                    return record.tradersCount;
                }
            },
            {
                key: "action",
                text: "Action",
                className: "action",
                align: "left",
                sortable: false,
                cell: (record) => {
                    return (
                        <Fragment>
                            <button
                                className="btn btn-primary btn-sm"
                                title="View Traders"
                                onClick={() => this.viewTraders(record)}
                                style={{ marginRight: "5px" }}
                            >
                                <i className="fa fa-eye"></i>
                            </button>
                        </Fragment>
                    );
                },
            },
        ];

        this.state = {
            totalCount: 0,
            records: [],
            offset: 0,
            pageSize: 10,
            sortOrder: {
                column: "_id",
                order: "desc"
            },
            loading: true,
            exportType: "current",
            extraButtons: [{
                className: "btn btn-primary buttons-pdf",
                title: "Export PDF",
                children: [
                    <span>
                        <i className="glyphicon glyphicon-print fa fa-file-pdf-o" aria-hidden="true"></i>
                    </span>,
                ],
                onClick: (event) => {
                    this.exportPDF();
                },
            },
            {
                className: "btn btn-primary buttons-csv",
                title: "Export CSV",
                children: [
                    <span>
                        <i className="glyphicon glyphicon-print fa fa-file-excel-o" aria-hidden="true"></i>
                    </span>
                ],
                onClick: (event) => {
                    this.exportCSV();
                },
            }],
            trader: ""
        };

        this.config = {
            page_size: this.state.pageSize,
            sort: this.state.sortOrder,
            length_menu: [10, 20, 50],
            no_data_text: "No followers found!",
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Filter in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last",
                },
            },
            key_column: "_id",
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            pagination: "advance",
            show_info: true,
            button: {
                extra: true,
            },
        };

        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        let trader = new URLSearchParams(this.props.location.search).get("trader");
        this.setState({ trader }, function() {
            this.getData();
        });
    }

    getData = async (filter = "") => {
        try {
            let data = {
                sortOrder:this.state.sortOrder,
                filter,
                trader: this.state.trader,
                limit: this.state.pageSize,
                offset: this.state.offset,
            };
            let { status, loading, result, totalCount } = await getFollowersHistory(data);
            if (status) {
                this.setState({ loading: false });
                this.setState({ records: result, totalCount:totalCount });
            }
        } catch (err) {}
    };

    search = data => {
        let filter = data.filter_value;
        let pageSize = data.page_size;
        let offset = (data.page_number-1)*pageSize;
        let sortOrder = data.sort_order ? data.sort_order:this.state.sortOrder;
        this.setState({ records:[], offset, pageSize, sortOrder, filter, loading: true }, function() {
            this.getData(filter);
        }); 
    }

    viewTraders(record) {
        this.props.history.push(`/top-traders?follower=${record._id}`);
    }

    exportCSV = async () => {

        let { sortOrder, filter, pageSize, offset, totalCount, exportType } = this.state;
        let data = {
            sortOrder,
            filter,
            limit: exportType == "current" ? pageSize:totalCount,
            offset: exportType == "current" ? offset:0,
            download: 1,
        };

        this.setState((prevState) => {
            let extraButtons = [...prevState.extraButtons];
            extraButtons[1].children = [<span><i className="fa fa-spinner fa-spin" aria-hidden="true"></i></span>];
            return { extraButtons };
        });

        let { status, result } = await getFollowersHistory(data);
        
        this.setState((prevState) => {
            let extraButtons = [...prevState.extraButtons];
            extraButtons[1].children = [
                <span><i className="glyphicon glyphicon-print fa fa-file-excel-o" aria-hidden="true"></i></span>
            ];
            return { extraButtons };
        });

        let records = status ? result: [];
        let separator = ";";
        let headers = [
            "User",
            "Total",
            "Gain",
            "Loss",
            "Profit And Loss (INR)",
            "P/L Ratio",
            "Following Traders",
        ];

        let rows = [];
        records.length > 0 && records.map((elt) => rows.push({
            "User": elt.user.name,
            "Total": elt.history ? elt.history.total : 0,
            "Gain": elt.history ? elt.history.gain : 0,
            "Loss": elt.history ? elt.history.loss : 0,
            "Profit And Loss (INR)": elt.history ? elt.history.profitnloss : 0,
            "P/L Ratio": elt.history ? elt.history.ratio : 0,
            "Following Traders": elt.tradersCount,
        }));

        let csvContent = `${headers.join(separator)}\n${rows.map((row) =>
            headers.map((k) => {
                let cell = row[k] === null || row[k] === undefined ? "" : row[k];

                cell = cell instanceof Date ? cell.toLocaleString():cell.toString().replace(/"/g, '""');

                if (cell.search(/("|,|\n)/g) >= 0) {
                    cell = `"${cell}"`;
                }
                return cell;
            }).join(separator)
        ).join("\n")}`;

        let title = "Followers";
        let blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
            // In case of IE 10+
            navigator.msSaveBlob(blob, title);
        } else {
            let link = document.createElement("a");
            if (link.download !== undefined) {
                // Browsers that support HTML5 download attribute
                let url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", title);
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };

    exportPDF = async () => {

        let { sortOrder, filter, pageSize, offset, totalCount, exportType } = this.state;
        let data = {
            sortOrder,
            filter,
            limit: exportType == "current" ? pageSize:totalCount,
            offset: exportType == "current" ? offset:0,
            download: 1,
        };

        this.setState((prevState) => {
            let extraButtons = [...prevState.extraButtons];
            extraButtons[0].children = [<span><i className="fa fa-spinner fa-spin" aria-hidden="true"></i></span>];
            return { extraButtons };
        });

        let { status, result } = await getFollowersHistory(data);
        
        this.setState((prevState) => {
            let extraButtons = [...prevState.extraButtons];
            extraButtons[0].children = [
                <span><i className="glyphicon glyphicon-print fa fa-file-pdf-o" aria-hidden="true"></i></span>
            ];
            return { extraButtons };
        });

        let records = status ? result: [];

        let unit = "pt";
        let size = "A4"; // Use A1, A2, A3 or A4
        let orientation = "landscape"; // portrait or landscape

        let marginLeft = 40;
        let doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(13);

        let title = "Followers";
        let headers = [[
            "User",
            "Total",
            "Gain",
            "Loss",
            "Profit And Loss (INR)",
            "P/L Ratio",
            "Following Traders",
        ]];

        let downloadData = records.length > 0 && records.map((elt) => [
            elt.user.name,
            elt.history ? elt.history.total : 0,
            elt.history ? elt.history.gain : 0,
            elt.history ? elt.history.loss : 0,
            elt.history ? elt.history.profitnloss : 0,
            elt.history ? elt.history.ratio : 0,
            elt.tradersCount,
        ]);

        let content = {
            startY: 50,
            head: headers,
            body: downloadData,
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("Followers.pdf");
    }

    render() {
        return (
            <div>
                <Navbar />
                <div className="d-flex" id="wrapper">
                    <Sidebar menuKey={this.props.menuKey} />
                    <div id="page-content-wrapper">
                        <div className="container-fluid">
                            <div className="float-xl-right">
                                Export
                                {["current", "all"].map((v) => (
                                    <Form.Check
                                        inline
                                        type="radio"
                                        name="exportType"
                                        value={v}
                                        key={v}
                                        onChange={(e) => this.setState({ exportType: e.target.value })}
                                        defaultChecked={v == this.state.exportType}
                                        label={firstLetterCase(v)}
                                    />
                                ))}
                            </div>
                            <h3 className="mt-2 text-secondary">
                                Followers List
                            </h3>
                            <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                dynamic={true}
                                loading={this.state.loading}
                                onChange={this.search}
                                total_record={this.state.totalCount}
                                extraButtons={this.state.extraButtons}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Followers;
